export const coresParaRotasOld: string[] = [
  '#e57373', '#ba68c8', '#5c6bc0', '#26c6da', '#60ad5e', '#ffa4a2', '#ee98fb', '#8e99f3', '#6ff9ff', '#005005',
  '#af4448', '#883997', '#26418f', '#0095a8', '#b71c1c', '#4a148c', '#42a5f5', '#00838f', '#f05545', '#7c43bd',
  '#80d6ff', '#4fb3bf', '#7f0000', '#0077c2', '#005662',
];

export const coresPrioridade: string[] = ['#0000FF', '#00FF00', '#FFFF00', '#FFA500', '#FF0000'];

export const coresParaRotasPathFind: string[] = [
  '#FF0000', '#0000FF', '#00FF00', '#FFFF00', '#00FFFF', '#FF00FF', '#FF5300', '#7F7F7F', '#BF0000', '#8080FF',
  '#006A00', '#FFFF6A', '#006A6A', '#FF95FF', '#FFBF80', '#000000', '#FF0080', '#BFFFFF', '#00AA00', '#8000FF',
  '#D5D500', '#B4B4B4', '#FF8000', '#00006A', '#FF4040', '#40FF40', '#D54500', '#6AFFFF', '#6A006A', '#FFFF55',
  '#555555', '#5555FF', '#800000', '#FF55AA', '#95FF95', '#FF702B', '#959500', '#009595', '#BF00BF', '#D5AAFF',
];

interface ColorUtilType {
  vibrant: boolean;
  one: [string];
  four: [string, string, string, string];
  ten: [string, string, string, string, string, string, string, string, string, string];
}

export const colorsUtils: { [key: string]: ColorUtilType } = {
  red: {
    vibrant: !0,
    one: ['#f44336'],
    four: ['#ff8a80', '#ff5252', '#ff1744', '#d50000'],
    ten: ['#ffebee', '#ffcdd2', '#ef9a9a', '#e57373', '#ef5350', '#f44336', '#e53935', '#d32f2f', '#c62828', '#b71c1c'],
  },
  pink: {
    vibrant: !0,
    one: ['#e91e63'],
    four: ['#ff80ab', '#ff4081', '#f50057', '#c51162'],
    ten: ['#fce4ec', '#f8bbd0', '#f48fb1', '#f06292', '#ec407a', '#e91e63', '#d81b60', '#c2185b', '#ad1457', '#880e4f'],
  },
  purple: {
    vibrant: !0,
    one: ['#9c27b0'],
    four: ['#ea80fc', '#e040fb', '#d500f9', '#aa00ff'],
    ten: ['#f3e5f5', '#e1bee7', '#ce93d8', '#ba68c8', '#ab47bc', '#9c27b0', '#8e24aa', '#7b1fa2', '#6a1b9a', '#4a148c'],
  },
  'deep-purple': {
    vibrant: !0,
    one: ['#673ab7'],
    four: ['#b388ff', '#7c4dff', '#651fff', '#6200ea'],
    ten: ['#ede7f6', '#d1c4e9', '#b39ddb', '#9575cd', '#7e57c2', '#673ab7', '#5e35b1', '#512da8', '#4527a0', '#311b92'],
  },
  indigo: {
    vibrant: !0,
    one: ['#3f51b5'],
    four: ['#8c9eff', '#536dfe', '#3d5afe', '#304ffe'],
    ten: ['#e8eaf6', '#c5cae9', '#9fa8da', '#7986cb', '#5c6bc0', '#3f51b5', '#3949ab', '#303f9f', '#283593', '#1a237e'],
  },
  blue: {
    vibrant: !0,
    one: ['#2196f3'],
    four: ['#82b1ff', '#448aff', '#2979ff', '#2962ff'],
    ten: ['#e3f2fd', '#bbdefb', '#90caf9', '#64b5f6', '#42a5f5', '#2196f3', '#1e88e5', '#1976d2', '#1565c0', '#0d47a1'],
  },
  'light-blue': {
    vibrant: !0,
    one: ['#03a9f4'],
    four: ['#80d8ff', '#40c4ff', '#00b0ff', '#0091ea'],
    ten: ['#e1f5fe', '#b3e5fc', '#81d4fa', '#4fc3f7', '#29b6f6', '#03a9f4', '#039be5', '#0288d1', '#0277bd', '#01579b'],
  },
  cyan: {
    vibrant: !0,
    one: ['#00bcd4'],
    four: ['#84ffff', '#18ffff', '#00e5ff', '#00b8d4'],
    ten: ['#e0f7fa', '#b2ebf2', '#80deea', '#4dd0e1', '#26c6da', '#00bcd4', '#00acc1', '#0097a7', '#00838f', '#006064'],
  },
  teal: {
    vibrant: !0,
    one: ['#009688'],
    four: ['#a7ffeb', '#64ffda', '#1de9b6', '#00bfa5'],
    ten: ['#e0f2f1', '#b2dfdb', '#80cbc4', '#4db6ac', '#26a69a', '#009688', '#00897b', '#00796b', '#00695c', '#004d40'],
  },
  green: {
    vibrant: !0,
    one: ['#4caf50'],
    four: ['#b9f6ca', '#69f0ae', '#00e676', '#00c853'],
    ten: ['#e8f5e9', '#c8e6c9', '#a5d6a7', '#81c784', '#66bb6a', '#4caf50', '#43a047', '#388e3c', '#2e7d32', '#1b5e20'],
  },
  'light-green': {
    vibrant: !0,
    one: ['#8bc34a'],
    four: ['#ccff90', '#b2ff59', '#76ff03', '#64dd17'],
    ten: ['#f1f8e9', '#dcedc8', '#c5e1a5', '#aed581', '#9ccc65', '#8bc34a', '#7cb342', '#689f38', '#558b2f', '#33691e'],
  },
  lime: {
    vibrant: !0,
    one: ['#cddc39'],
    four: ['#f4ff81', '#eeff41', '#c6ff00', '#aeea00'],
    ten: ['#f9fbe7', '#f0f4c3', '#e6ee9c', '#dce775', '#d4e157', '#cddc39', '#c0ca33', '#afb42b', '#9e9d24', '#827717'],
  },
  yellow: {
    vibrant: !0,
    one: ['#ffeb3b'],
    four: ['#ffff8d', '#ffff00', '#ffea00', '#ffd600'],
    ten: ['#fffde7', '#fff9c4', '#fff59d', '#fff176', '#ffee58', '#ffeb3b', '#fdd835', '#fbc02d', '#f9a825', '#f57f17'],
  },
  amber: {
    vibrant: !0,
    one: ['#ffc107'],
    four: ['#ffe57f', '#ffd740', '#ffc400', '#ffab00'],
    ten: ['#fff8e1', '#ffecb3', '#ffe082', '#ffd54f', '#ffca28', '#ffc107', '#ffb300', '#ffa000', '#ff8f00', '#ff6f00'],
  },
  orange: {
    vibrant: !0,
    one: ['#ff9800'],
    four: ['#ffd180', '#ffab40', '#ff9100', '#ff6d00'],
    ten: ['#fff3e0', '#ffe0b2', '#ffcc80', '#ffb74d', '#ffa726', '#ff9800', '#fb8c00', '#f57c00', '#ef6c00', '#e65100'],
  },
  'deep-orange': {
    vibrant: !0,
    one: ['#ff5722'],
    four: ['#ff9e80', '#ff6e40', '#ff3d00', '#dd2c00'],
    ten: ['#fbe9e7', '#ffccbc', '#ffab91', '#ff8a65', '#ff7043', '#ff5722', '#f4511e', '#e64a19', '#d84315', '#bf360c'],
  },
  brown: {
    vibrant: !1,
    one: ['#795548'],
    four: ['#d7ccc8', '#8d6e63', '#6d4c41', '#4e342e'],
    ten: ['#efebe9', '#d7ccc8', '#bcaaa4', '#a1887f', '#8d6e63', '#795548', '#6d4c41', '#5d4037', '#4e342e', '#3e2723'],
  },
  grey: {
    vibrant: !1,
    one: ['#9e9e9e'],
    four: ['#f5f5f5', '#bdbdbd', '#757575', '#424242'],
    ten: ['#fafafa', '#f5f5f5', '#eeeeee', '#e0e0e0', '#bdbdbd', '#9e9e9e', '#757575', '#616161', '#424242', '#212121'],
  },
  'blue-grey': {
    vibrant: !1,
    one: ['#607d8b'],
    four: ['#cfd8dc', '#78909c', '#546e7a', '#37474f'],
    ten: ['#eceff1', '#cfd8dc', '#b0bec5', '#90a4ae', '#78909c', '#607d8b', '#546e7a', '#455a64', '#37474f', '#263238'],
  },
  asphalt: {
    vibrant: !1,
    one: ['#273746'],
    four: ['#D6DBDF', '#5D6D7E', '#2E4053', '#212F3C'],
    ten: ['#EBEDEF', '#D6DBDF', '#AEB6BF', '#85929E', '#5D6D7E', '#34495E', '#2E4053', '#283747', '#212F3C', '#1B2631'],
  },
};
const names: string[] = [];
const order: number[] = [];
let ini = -1;
Object.entries(colorsUtils).forEach(([i]) => {
  names.push(i);
  order.push(((ini + 7 <= 25) || (ini += 2)) && (ini = (ini += 7) % 20));
});
export const paleta: { [key: string]: string[] } = {primary: [], primaryInverse: [], vibrant: [], vibrantDouble: []};
const arr1: string[] = [];
const arr2: string[] = [];
order.forEach((pos, i) => {
  const cor = names[pos];
  const four = colorsUtils[cor].four;
  if (four instanceof Array) {
    paleta.primary.push(four[1]);
    if (colorsUtils[cor].vibrant) {
      paleta.vibrant.push(four[2]);
      arr1.push(four[1]);
      arr2.push(four[3]);
    }
  }
  // @ts-ignore
  paleta.primaryInverse.push(colorsUtils[names[order[order.length - 1 - i]]].four[1]);
});
paleta.vibrantDouble = paleta.vibrantDouble.concat(arr1).concat(arr2);

export const coresParaRotas: string[] = paleta.vibrantDouble;

export const colorsNames: { [key: string]: string } = {
  aliceblue: '#f0f8ff',
  antiquewhite: '#faebd7',
  aqua: '#00ffff',
  aquamarine: '#7fffd4',
  azure: '#f0ffff',
  beige: '#f5f5dc',
  bisque: '#ffe4c4',
  black: '#000000',
  blanchedalmond: '#ffebcd',
  blue: '#0000ff',
  blueviolet: '#8a2be2',
  brown: '#a52a2a',
  burlywood: '#deb887',
  cadetblue: '#5f9ea0',
  chartreuse: '#7fff00',
  chocolate: '#d2691e',
  coral: '#ff7f50',
  cornflowerblue: '#6495ed',
  cornsilk: '#fff8dc',
  crimson: '#dc143c',
  cyan: '#00ffff',
  darkblue: '#00008b',
  darkcyan: '#008b8b',
  darkgoldenrod: '#b8860b',
  darkgray: '#a9a9a9',
  darkgreen: '#006400',
  darkkhaki: '#bdb76b',
  darkmagenta: '#8b008b',
  darkolivegreen: '#556b2f',
  darkorange: '#ff8c00',
  darkorchid: '#9932cc',
  darkred: '#8b0000',
  darksalmon: '#e9967a',
  darkseagreen: '#8fbc8f',
  darkslateblue: '#483d8b',
  darkslategray: '#2f4f4f',
  darkturquoise: '#00ced1',
  darkviolet: '#9400d3',
  deeppink: '#ff1493',
  deepskyblue: '#00bfff',
  dimgray: '#696969',
  dodgerblue: '#1e90ff',
  firebrick: '#b22222',
  floralwhite: '#fffaf0',
  forestgreen: '#228b22',
  fuchsia: '#ff00ff',
  gainsboro: '#dcdcdc',
  ghostwhite: '#f8f8ff',
  gold: '#ffd700',
  goldenrod: '#daa520',
  gray: '#808080',
  green: '#008000',
  greenyellow: '#adff2f',
  honeydew: '#f0fff0',
  hotpink: '#ff69b4',
  indianred: '#cd5c5c',
  indigo: '#4b0082',
  ivory: '#fffff0',
  khaki: '#f0e68c',
  lavender: '#e6e6fa',
  lavenderblush: '#fff0f5',
  lawngreen: '#7cfc00',
  lemonchiffon: '#fffacd',
  lightblue: '#add8e6',
  lightcoral: '#f08080',
  lightcyan: '#e0ffff',
  lightgoldenrodyellow: '#fafad2',
  lightgrey: '#d3d3d3',
  lightgreen: '#90ee90',
  lightpink: '#ffb6c1',
  lightsalmon: '#ffa07a',
  lightseagreen: '#20b2aa',
  lightskyblue: '#87cefa',
  lightslategray: '#778899',
  lightsteelblue: '#b0c4de',
  lightyellow: '#ffffe0',
  lime: '#00ff00',
  limegreen: '#32cd32',
  linen: '#faf0e6',
  magenta: '#ff00ff',
  maroon: '#800000',
  mediumaquamarine: '#66cdaa',
  mediumblue: '#0000cd',
  mediumorchid: '#ba55d3',
  mediumpurple: '#9370d8',
  mediumseagreen: '#3cb371',
  mediumslateblue: '#7b68ee',
  mediumspringgreen: '#00fa9a',
  mediumturquoise: '#48d1cc',
  mediumvioletred: '#c71585',
  midnightblue: '#191970',
  mintcream: '#f5fffa',
  mistyrose: '#ffe4e1',
  moccasin: '#ffe4b5',
  navajowhite: '#ffdead',
  navy: '#000080',
  oldlace: '#fdf5e6',
  olive: '#808000',
  olivedrab: '#6b8e23',
  orange: '#ffa500',
  orangered: '#ff4500',
  orchid: '#da70d6',
  palegoldenrod: '#eee8aa',
  palegreen: '#98fb98',
  paleturquoise: '#afeeee',
  palevioletred: '#d87093',
  papayawhip: '#ffefd5',
  peachpuff: '#ffdab9',
  peru: '#cd853f',
  pink: '#ffc0cb',
  plum: '#dda0dd',
  powderblue: '#b0e0e6',
  purple: '#800080',
  rebeccapurple: '#663399',
  red: '#ff0000',
  rosybrown: '#bc8f8f',
  royalblue: '#4169e1',
  saddlebrown: '#8b4513',
  salmon: '#fa8072',
  sandybrown: '#f4a460',
  seagreen: '#2e8b57',
  seashell: '#fff5ee',
  sienna: '#a0522d',
  silver: '#c0c0c0',
  skyblue: '#87ceeb',
  slateblue: '#6a5acd',
  slategray: '#708090',
  snow: '#fffafa',
  springgreen: '#00ff7f',
  steelblue: '#4682b4',
  tan: '#d2b48c',
  teal: '#008080',
  thistle: '#d8bfd8',
  tomato: '#ff6347',
  turquoise: '#40e0d0',
  violet: '#ee82ee',
  wheat: '#f5deb3',
  white: '#ffffff',
  whitesmoke: '#f5f5f5',
  yellow: '#ffff00',
  yellowgreen: '#9acd32',
};
